export default __webpack_public_path__ + "static/media/oldPurchases1.a1b64b97.jpg";